import {
  PC_SIMULATION_START,
  PC_SIMULATION_END,
  PC_SIMULATION_RESULT,
} from './PriceComplianceSimulation.ActionTypes';
import axios from '../../../axios.conf';
import { history } from '../../../components/Helpers';
import { toast as globalToast } from '../../../components/ToastManager';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

export const PriceComplianceSimulationTypes = (type, data) => {
  return { type, data };
};

const simulatePriceComplianceCalculation = (payload, apiPath) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post(apiPath, payload, { headers });
};

export const runPriceComplianceCalculationSimulation = (payload, apiPath) => {
  return async (dispatch) => {
    dispatch(PriceComplianceSimulationTypes(PC_SIMULATION_START));
    try {
      const response = await simulatePriceComplianceCalculation(payload, apiPath);
      dispatch(PriceComplianceSimulationTypes(PC_SIMULATION_END));
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (response.data.result && response.data.result.length > 0) {
          dispatch(PriceComplianceSimulationTypes(PC_SIMULATION_RESULT, response.data));
          history.push('/price-compliance-calculation-simulation/results');
        }
      } else {
        if (response.data.result && response.data.result.length > 0) {
          dispatch(PriceComplianceSimulationTypes(PC_SIMULATION_RESULT, response.data));
          history.push('/price-compliance-calculation-simulation/results');
        } else {
          globalToast.showWarning('No records found.');
        }
      }
    } catch (error) {
      dispatch(PriceComplianceSimulationTypes(PC_SIMULATION_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        await handleExecutionLog(dispatch, logNumber);
      }
    }
  };
};
